var React = require('react');

function CtaArrowInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"className":"a","d":"M16,4.307A9.691,9.691,0,0,0,11.2,8h-.877a9.783,9.783,0,0,1,1.988-3.38H0V3.393H12.309A9.756,9.756,0,0,1,10.321,0H11.2A9.691,9.691,0,0,0,16,3.693Z"}));
}

CtaArrowInline.defaultProps = {"width":"16","height":"8","viewBox":"0 0 16 8"};

module.exports = CtaArrowInline;

CtaArrowInline.default = CtaArrowInline;
